import React from 'react';
import { COLORS } from '../../styles/variables';

interface ArrowProps {
  size?: number;
  color?: string;
}

const ArrowRightIcon: React.FC<ArrowProps> = ({ size = 24, color = COLORS.grey60 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.49992 17.439L14.9849 11.996L9.50492 6.56103" stroke={color} />
    </svg>
  );
};

export default ArrowRightIcon;
